import { ApplicationConfigDto } from '@shelflix/trpc/routes/applicationConfig/get/useCase';
import { create } from 'zustand';

interface ConfigStore {
  config: ApplicationConfigDto | null;
  setConfig: (config: ApplicationConfigDto) => void;
}

// No persistence needed - config is always fetched from server on page load
// via initApp() in main.tsx, which determines tenant from domain
export const useConfigStore = create<ConfigStore>()((set) => ({
  config: null,
  setConfig: (config) => set({ config }),
}));
